import { appAppleStoreLink, appGoogleStoreLink } from '@core/consts';
import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import { StaticImage } from 'gatsby-plugin-image';
import React, { FC } from 'react';

import WidgetBtn from './component/Btn';

type Props = StyleProps & TestIdProps;

export const PostGetTheAppWidget: FC<Props> = ({ testId, className }) => {
  return (
    <div data-testid={testId} className={mc('2xl:pt-14', className)}>
      <div className={mc('relative', 'pl-8 pr-8 sm:pr-[334px] py-12', 'border border-seafoam rounded-lg box-border')}>
        <div className={mc('text-center sm:text-left', 'text-3xl font-literata leading-tight font-medium text-ocean-blue')}>
          {`Build your own circle of care`}
        </div>
        <div className={mc('text-center sm:text-left', 'text-lg font-raleway leading-normal font-medium text-primary-black-700')}>
          {`Download the app and give it a try. It's free!`}
        </div>
        <div className={mc('mt-4 2xl:mt-2.5', 'flex flex-col 2xl:flex-row')}>
          <WidgetBtn className="mb-4 2xl:mb-0 2xl:mr-1" href={appAppleStoreLink} target="__blank" icon="ios" color="ocean-blue">
            {'Get on App Store'}
          </WidgetBtn>
          <WidgetBtn className="2xl:ml-1" href={appGoogleStoreLink} target="__blank" icon="android" color="accent-green">
            {'Get on Google Play'}
          </WidgetBtn>
        </div>
        <div className={mc('hidden sm:block', 'absolute right-0 bottom-0')}>
          <StaticImage width={318} src="./assets/background.png" alt="CircleOf Mobile App" />
        </div>
      </div>
    </div>
  );
};

export type PostGetTheAppWidgetProps = Props;
export default PostGetTheAppWidget;
